<div class="map-toolbox">
  <button
    type="button"
    (click)="zoomIn()"
    aria-label="Acercar mapa"
  >
    <span aria-hidden="true">+</span>
  </button>
  <button
    type="button"
    (click)="zoomOut()"
    aria-label="Alejar mapa"
  >
    <span aria-hidden="true">-</span>
  </button>
  <button
    type="button"
    [class.active]="visible"
    (click)="toggleVisible()"
    aria-label="Mostrar u ocultar capas"
    [attr.aria-expanded]="visible"
  >
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m12 3 8 4-8 4-8-4 8-4Z" />
      <path d="m4 12 8 4 8-4" />
      <path d="m4 17 8 4 8-4" />
    </svg>
  </button>
  <button
    type="button"
    [class.active]="featureInfoActive"
    (click)="toggleFeatureInfo()"
    [attr.aria-label]="featureInfoActive ? 'Desactivar consulta de información' : 'Activar consulta de información'"
    [attr.aria-pressed]="featureInfoActive"
    title="Consultar información del mapa"
  >
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 10.5v6" />
      <path d="M12 7.5h.01" />
    </svg>
  </button>
</div>

@if (visible) {
  <aside class="public-layers-panel" aria-label="Capas del visor">
    <header>
      <h2>Capas</h2>
      <button type="button" (click)="close()" aria-label="Cerrar capas">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>
    </header>

    @if (grouped) {
      <div class="layer-groups">
        @for (group of layerGroups; track group.label) {
          <section class="layer-group" [attr.aria-label]="group.label">
            <h3>{{ group.label }}</h3>

            <div class="layer-group-items">
              @for (layer of group.layers; track layer.name) {
                <label class="public-layer-toggle">
                  <input
                    type="checkbox"
                    [(ngModel)]="layer.enabled"
                    (ngModelChange)="toggleLayer(layer, $event)"
                  />
                  <span>{{ layer.groupLabel ?? layer.label }}</span>
                </label>
              }
            </div>
          </section>
        }
      </div>
    } @else {
      @for (layer of displayLayers; track layer.name) {
        <label class="public-layer-toggle">
          <input
            type="checkbox"
            [(ngModel)]="layer.enabled"
            (ngModelChange)="toggleLayer(layer, $event)"
          />
          <span>{{ layer.label }}</span>
        </label>
      }
    }
  </aside>
}
